<template>
  <div class="component-library">
    <div class="title-component">COMPONENT</div>

    <!-- Input Search -->
    <div class="input-search">
      <i class="fa fa-search" />
      <input
        v-model="searchComponent"
        type="text"
        placeholder="Search"
        autocomplete="off"
      >
    </div>

    <!-- Field List -->
    <div
      v-if="isLoading"
      class="content-component"
    >
      <!-- Skeleton Fields -->
      <j-skeleton-component-app />
    </div>

    <div
      v-else
      class="content-component"
    >
      <div
        v-for="(section, index) in componentsLibrary"
        :key="section.type"
        class="field-section"
      >
        <p
          class="title-section"
          @click="section.collapse = !section.collapse"
        >
          <i
            :class="{'collapsed': section.collapse}"
            class="fa fa-caret-right"
          />
          {{ `${section.section_name} (${section.components.length})` }}
        </p>

        <!-- Field List -->
        <draggable
          :list="section.components"
          :group="{ name: 'componentLibrary', pull: 'clone', put: false }"
          :class="{'collapsed': section.collapse}"
          class="field-list"
          @start="dragStart($event, index)"
          @end="reset($event, index)"
        >
          <div
            v-for="component in section.components"
            :key="component.id"
            class="list"
          >
            <img
              :src="require(`@/assets/new-form-ui/field-icon-active/${section.type}.svg`)"
              class="field-icon field-icon-active"
            >
            <img
              :src="require(`@/assets/new-form-ui/field-icon/${section.type}.svg`)"
              class="field-icon field-icon-default"
            >
            <span>{{ component.name.replace(/_/g, ' ') }}</span>
          </div>
        </draggable>

        <j-skeleton-component-app
          v-if="section.loadingSeeMore"
          :length="1"
        />

        <div
          v-if="section.useSeeMore &&
            !section.loadingSeeMore &&
            !section.hideSeeMore &&
          !section.collapse"
          class="d-flex justify-content-center align-items-center"
        >
          <p
            class="btn-see-more"
            @click="configGetDataComponent[index].service(index)"
          >
            See More <i class="fa fa-chevron-down" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len, no-param-reassign */
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import draggable from 'vuedraggable';
import jSkeletonComponentApp from '@/views/experience-manager-v2/loading/jSkeletonComponentApp';
// Mixins
import jMixLayoutDummy from '@/mixins/app-manager/jMixLayoutDummy';

export default {
  components: {
    draggable,
    jSkeletonComponentApp,
  },

  mixins: [
    jMixLayoutDummy,
  ],

  data() {
    return {
      isLoading: true,
      searchComponent: '',
      componentsLibrary: [],
      componentSelected: null,
      isSearch: false,
    };
  },

  computed: {
    ...mapState('jStoreApplication', ['list_component_master']),
  },

  watch: {
    searchComponent(val) {
      if (val.length > 0) {
        const dataComponents = this._.cloneDeep(this.componentsList);

        dataComponents.forEach((e, index) => {
          if (e.useSeeMore) {
            dataComponents[index].loadingSeeMore = true;
            dataComponents[index].components = [];
          } else {
            dataComponents[index].components = e.components.filter(field => field.name.toLowerCase().includes(val.toLowerCase()));
          }
        });

        this.componentsLibrary = dataComponents;
        this.configGetDataComponent.forEach((e, index) => { this.configGetDataComponent[index].page = 1; });
        this.debouncedSearch();
        this.isSearch = true;
      } else {
        this.refreshDataComponents();
        this.isSearch = false;
      }
    },
  },

  created() {
    this.getListComponentMaster();
  },

  methods: {
    ...mapActions('jStoreApplication', ['listComponentMaster']),

    // eslint-disable-next-line
    debouncedSearch: _.debounce(function () { if (this.searchComponent) this.getListFormUI(); }, 1000),

    getListComponentMaster() {
      const parameter = {
        limit: 0,
        page: 1,
        column: 'id',
        sort: 'asc',
        query: '',
        query_type: '',
      };
      this.listComponentMaster({ params: parameter }).then(() => {
        this.getListFormUI();
      });
    },

    refreshDataComponents() {
      this.isLoading = true;
      this.componentsLibrary = this._.cloneDeep(this.componentsList);
      setTimeout(() => {
        this.isLoading = false;
      }, 400);
    },

    dragStart(event, index) {
      const data = this.componentsLibrary[index].components[event.oldIndex];
      this.componentSelected = data.id;
    },

    reset(data, index) {
      const oldIndex = data.oldIndex;
      const newIndex = this.componentsLibrary[index].components.findIndex(field => field.id === this.componentSelected);
      const element = this.componentsLibrary[index].components[newIndex];

      this.componentsLibrary[index].components.splice(newIndex, 1);
      this.componentsLibrary[index].components.splice(oldIndex, 0, element);
      this.componentSelected = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/jComponentLibrary.vue